/* global window, rp$, rp_app */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
'use strict';

/**
* Cart
* @author aspencer
* @dependies: jquery
*/
require('core-js/fn/array/is-array');
require('core-js/fn/array/for-each');

const debounce = require('lodash/debounce');
const get = require('lodash/get');

const dust = require('public/js/lib/dust');
const onReady = require('public/js/lib/on-ready');
const RP_Product = require('public/js/components/product');
const paypal = require('public/js/components/paypal');

const add_dialog_templ = require('public/js/templates/cart/add-dialog.dust');
const cart_templ = require('public/js/templates/cart/cart.dust');
const cart_promo_templ = require('public/js/templates/cart/cart-promo.dust');
const collect_vin_templ = require('public/js/templates/cart/collect-vin.dust');
const NumberFormat = require('@revolutionparts/number-format')();
const numbro = require('numbro');

const ERRORS = {
	types: {
		error: 'error',
		warning: 'warning',
	},
	codes: {
		single_warehouse_cart_restriction: 15104,
		single_warehouse_no_brand_support: 15105,
	},
};

require('public/css/components/add-to-cart.scss');


window.rp_app = rp_app || {};

/**
* RP Cart Constructor
*
* @author aspencer
* @return null
*/
var RP_Cart = function() {
	this._cart_ele_id 	= 'rp_global_add_to_cart';
	this._cart_ele 		= null;
	this._vin_ele_id 	= 'rp_global_collect_vin';
	this._vin_ele 		= null;
	this._currency_symbol 	= window.CurrencySymbol || '$';
	this._currency_code 	= window.CurrencyCode || '';
	this._checkout_url 		= window.CartCheckoutUrl || '';
	this._current_product 	= null;
	this._punchout_session	= window.punchout_session;
	this._start_checkout_url= null;
	this._prevent_checkout	= (typeof rp$('.cart-flyout .cart-listing').data('prevent-checkout') !== 'undefined');
	this._paypal_ec_enabled	= (typeof rp$('.cart-flyout .cart-listing').data('paypal-ec-enabled') !== 'undefined');
	this._paypal_ec_api_token	= rp$('.cart-flyout .cart-listing').data('paypal-ec-api-token');
	this._paypal_ec_api_env	= rp$('.cart-flyout .cart-listing').data('paypal-ec-api-env');

	/* Debug Mode
	.*------------------------------------------*/
	this.debug_mode = false;

	/* Handle multiple attempts of save_cart in case of failure
	.*-----------------------------------------*/
	this._max_retries = 3;
	this._save_attempt_count = 0;

	/* Store the save request if we're already in the process of updating
	* Use this as a buffer to decrease server chatter on update
	.*-----------------------------------------*/
	this._current_save_request = null;
	this._waiting_save_request = null;

	/* Cart Container
	* Always loaded fresh from the server on init
	.*-----------------------------------------*/
	this.cart_id	= 0;
	this.cart 		= [];
	this.item_count = 0;
	this.subtotal 	= 0;
	this._cart_product_map = {};

	// Load the cart from the global space if it exists
	if(window.rp_cart) {
		this.init_cart(window.rp_cart);
	} else {
		this.fetch_cart();
	}

	/* Create an element for vin collection & cart confirmation
	.*-----------------------------------------*/
	this._cart_ele = this.global_ele(this._cart_ele_id);
	this._vin_ele = this.global_ele(this._vin_ele_id);
};


/**
* Add a product to the cart from a DOM Element (usually an add-to-cart button)
*
* @author aspencer
* @param  DOMElement 		add_product_ele 	DOM Element containing product info as data-* attrs
* @return null
*/
RP_Cart.prototype.add_product_from_ele = function(add_product_ele) {
	this.clear_current_product();
	var rp_product = new RP_Product(add_product_ele, 'DOM');

	/* Check to see if a quantity box is available - set quantity from that if it exists
	.*-----------------------------------------*/
	var $quanity_input_ele = rp$('.input-quantity');
	if($quanity_input_ele.length > 0) {
		rp_product.set_quantity($quanity_input_ele.val());
	}

	/* Add the item if it is allowed
	.*-----------------------------------------*/
	if(rp_product.get_cart_allowed()) {
		var is_updated = this.add_product(rp_product);
		rp_product.set_cart_updated(is_updated);
		this.set_current_product(rp_product);
		if(rp_product.can_add_to_cart()) {
			this.request_save_product();
		}
	}
};



/**
* Adds a product element to the cart
*
* @author aspencer
* @param  RP_Product 	rp_product 	 	Product to add to the cart
* @return boolean						Whether or not the item was new (added) or existing (updated)
*/
RP_Cart.prototype.add_product = function(rp_product) {
	var is_updated = false;
	var key = rp_product.get_cart_key();

	/* Check to see if the item already exists
	.*-----------------------------------------*/
	if(this._cart_product_map[key] !== undefined) {
		// Item already exists in the cart.
		var idx = this._cart_product_map[key];
		var existing_product = this.cart[idx].product;
		// Increment the quantity of added item
		rp_product.add_quantity(existing_product.get_quantity());
		// Pull the cart_item_id from the existing item
		rp_product.set_cart_item_id(existing_product.get_cart_item_id());
		// Replace the existing item with the new on
		// (Replace because added item is likely to be more complete)
		this.cart[idx].product = rp_product;
		is_updated = true;
	} else {
		// Item is new. Add to cart
		var new_idx = this.cart.length;
		this.cart.push({product: rp_product});
		this._cart_product_map[key] = new_idx;
	}

	return is_updated;
};


/********************************************
* Cart Functions
* -----------------------------------------
* @section cart
********************************************/

RP_Cart.prototype.fetch_cart = function () {
	$ajax({
		type: 'GET',
		url: '/ajax/cart',
		dataType: 'json',
		contentType: 'application/json',
		success: (return_data/*, text_status, xhr*/) => {
			this.set_cart(return_data);
			this._checkout_url = return_data.checkoutUrl;
		}
	});
};

/**
* Initializes cart from JSON object
* usually happens as the object is being created
*
* @author aspencer
* @param  JSON object 	json_cart	Object representing cart
* @return null
*/
RP_Cart.prototype.init_cart = function(rp_cart) {
	if(this.debug_mode) {
		console.info('initial cart', rp_cart);
	}

	/* Load up the cart contents from the object
	.*-----------------------------------------*/
	this.clear_cart();
	var rp_cart_items = rp_cart.items;
	if(rp_cart_items) {
		for(var i = 0, j = rp_cart_items.length; i < j; i++) {
			var cart_item = rp_cart_items[i];

			/* Create the product object and set the quanity
			.*-----------------------------------------*/
			var product = new RP_Product(cart_item);
			var quantity = (cart_item.quantity) ? parseInt(cart_item.quantity) : 1;
			product.set_quantity(quantity);
			// Add the product to the cart
			this.add_product(product);
		}
	}

	/* Update cart totals
	.*-----------------------------------------*/
	this.update_totals();
};

/**
* Set the cart from a JSON object
* Similar to the operations in init_cart, but resets quantities instead of adding to them
* Also deletes existing items if they don't exist in input object
*
* @author aspencer
* @param  JSON object 	json_cart	Object representing cart
* @return null
*/
RP_Cart.prototype.set_cart = function(rp_cart) {
	this.cart_id = rp_cart.id;

	/* create a map of products that we add or update
	.*-----------------------------------------*/
	var _product_updated_map = {},
		key, return_rp_product, i, j, rp_idx, rp_product;

	/* Rebuild Cart items from cart response
	.*-----------------------------------------*/
	var rp_cart_items = rp_cart.items;
	if(!rp_cart_items) {
		rp_cart_items = [];
	}

	for(i = 0, j = rp_cart_items.length; i < j; i++) {
		return_rp_product = new RP_Product(rp_cart_items[i]);
		key = return_rp_product.get_cart_key();
		if(this.debug_mode) {
			console.info(key, '...maps to...', this._cart_product_map[key], 'using: ', this._cart_product_map);
		}

		/* Check to see if the item currently exists in the cart
		.*-----------------------------------------*/
		if(this._cart_product_map[key] !== undefined) {
			/* If so, set the qty and item_id from the object
			.*-----------------------------------------*/
			rp_idx = this._cart_product_map[key];
			rp_product = this.cart[rp_idx].product;
			rp_product.set_quantity(return_rp_product.get_quantity());
			if(return_rp_product.get_quantity() === 0) {
				rp_product.set_cart_item_id(null);
			}
			rp_product.set_cart_item_id(return_rp_product.get_cart_item_id());
			this.cart[rp_idx].product = rp_product;
		} else {
			/* Otherwise, add it
			.*-----------------------------------------*/
			this.add_product(return_rp_product);
		}


		/* Note that we have updated this product
		.*-----------------------------------------*/
		_product_updated_map[key] = true;
	}

	/* Validate Updated products against the current map of products
	* (if a product doesn't exist in updated products, it needs to be removed)
	.*-----------------------------------------*/
	for(key in this._cart_product_map) {
		if(!_product_updated_map.hasOwnProperty(key)) {
			rp_idx = this._cart_product_map[key];
			rp_product = this.cart[rp_idx].product;
			rp_product.set_quantity(0);
			rp_product.set_cart_item_id(null);
			this.cart[rp_idx].product = rp_product;
		}
	}

	/* Update cart totals
	.*-----------------------------------------*/
	this.update_totals();
};

/**
* Clear the contents of the cart
*
* @author aspencer
* @return null
*/
RP_Cart.prototype.clear_cart = function() {
	this.cart = [];
	this._cart_product_map = {};
};

/**
* Update Totals and Count from current cart object
*
* @author aspencer
* @return null
*/
RP_Cart.prototype.update_totals = function() {
	this.subtotal = 0;
	this.item_count = 0;

	for(var i = 0, j = this.cart.length; i < j; i++) {
		var cart_row = this.cart[i];
		this.subtotal += cart_row.product.get_total_price();
		this.item_count += cart_row.product.get_quantity();
	}
};

/********************************************
* Collect VIN functionality
* -----------------------------------------
* @section collect_vin
********************************************/

RP_Cart.prototype.collect_vin = function(vin_number) {
	var rp_product = this._current_product;

	if (vin_number.length !== 17) {
		window.alert('The VIN you entered was not valid, please retry.');
		return;
	}

	rp_product.set_vin(vin_number);
	this.close_dialog();
	this.open_cart();

	if(rp_product.can_add_to_cart()) {
		this.request_save_product();
	}
};


/********************************************
* Saving Changes to server
* -----------------------------------------
* @section saving
********************************************/

/**
* Request a save from the object, handles volume of requests from input elements
*
* @author aspencer
* @return null
*/
RP_Cart.prototype.request_save_product = function(options) {
	var opts = options || {};
	if (typeof opts.callback !== 'function') {
		opts.callback = rp$.noop;
	}

	if(this._current_save_request) {
		this._waiting_save_request = true;
	} else {
		this.save_product(opts);
	}
};

/**
* Saves the current item to the sever
*
* @author aspencer
* @return null
*/
RP_Cart.prototype.save_product = debounce(function(options) {
	this._current_save_request = true;

	var opts = options || {};
	var callback = opts.callback || rp$.noop;
	var rp_product = this._current_product;
	if(!rp_product) { return; }

	// Build update data
	var update_data = rp_product.get_cart_json();
	if (opts.replace) {
		update_data.replace = true;
	}

	// Add a data attr if this add to cart click was the result of a product search.
	var $addToCartBtn = rp$('.add-to-cart');
	if ($addToCartBtn && $addToCartBtn.length) {
		var fromSearch = $addToCartBtn.data('from-search');
		update_data.from_search = fromSearch;
		if (fromSearch) {
			// TODO: SMK 11/9/18 -- Potentially log events to GA here, or update the existing add to cart tracking.
		}
	}


	/* Increase the attempt count IDX
	.*-----------------------------------------*/
	this._save_attempt_count++;
	if(this.debug_mode) {
		console.info('UPDATE', update_data, JSON.stringify(update_data));
	}
	var self = this;
	$ajax({
		type: 'POST',
		url: '/ajax/cart/update',
		data: JSON.stringify(update_data),
		dataType: 'json',
		contentType: 'application/json',
		success: function(return_data/*, text_status, xhr*/) {
			if(self.debug_mode) {
				console.info('RESPONSE', return_data, JSON.stringify(return_data));
			}
			rp_app.notify.clear_notifications();

			if(return_data.checkoutUrl) {
				self._checkout_url = return_data.checkoutUrl;
			}
			if(return_data.startCheckoutUrl) {
				self._start_checkout_url = return_data.startCheckoutUrl;
			}

			/* Only rebuild totals if something has changed on the server
			 * This prevents some UX jank
			.*-----------------------------------------*/
			let current_subtotal = numbro(self.subtotal).format('0.00');
			let return_subtotal = numbro(return_data.subtotalAmount).format('0.00');
			if(!self._waiting_save_request && current_subtotal !== return_subtotal) {
				self.set_cart(return_data);
				self.update_totals();
				self.build_html();
			}
			// Always rebuild the cart
			self.build_cart_html();
			if (return_data.inventory_message) {
				var $addToCartBtn = rp$('#added_product_img');
				var $inventoryMessage = rp$('.inventory.message');
				var $fancyBoxInner = rp$('.fancybox-inner');

				//Replace the HTML with the inventory message if there isn't already an inventory message in the box
				if ($addToCartBtn && $inventoryMessage && $fancyBoxInner && ($inventoryMessage.html() === '')) {
					// Adjust style of modal to fit the message
					$addToCartBtn.removeClass('centered');
					$fancyBoxInner.css('height', ''); // Removing static height in the event of a long message
					$inventoryMessage.html(return_data.inventory_message);
				}
			}

			if (return_data.cart_promo_message) {
				self.update_cart_promo_html(return_data.cart_promo_message);
			}

			/* Handle Errors
			.*-----------------------------------------*/
			const responseErrors = get(return_data, 'errors', []);
			const responseError = {
				type: null,
				code: null,
				message: null,
			};
			if (Array.isArray(responseErrors) && responseErrors.length > 0) {
				// condense any errors down to a single error response
				responseErrors.forEach(error => {
					const type = get(error, 'type', ERRORS.types.error);

					let replace = true;
					if (type === ERRORS.types.warning && responseError.type === ERRORS.types.error) {
						replace = false;
					}

					if (replace) {
						responseError.type = type;
						responseError.code = get(error, 'code', 0);
						responseError.message = get(error, 'message');
					}
				});
			}

			// display error message if it exists
			if (responseError.message && responseError.type) {
				self.empty_notifications();
				if (responseError.type === ERRORS.types.warning) {
					self._cart_ele.addClass('save_warning');
				} else {
					self._cart_ele.addClass('save_failed');
				}

				let displayMessage = responseError.message;
				switch (responseError.code) {
					case ERRORS.codes.single_warehouse_cart_restriction:
						displayMessage = `One or more of the brands already in your cart can't ship with the brand you are attempting to add. Would you like to proceed with your existing cart or <a href="javascript:;" class="replace-cart">continue with the new part</a>?`;
						window.rp_app.track.track_event(['AddToCart', 'SingleWarehouseRestriction', 'DisplayMessage']);
						break;
					case ERRORS.codes.single_warehouse_no_brand_support:
						displayMessage = `Unfortunately, we're unable to ship this item at this time.`;
						window.rp_app.track.track_event(['AddToCart', 'SingleWarehouseRestriction', 'NoBrandSupport']);
						break;
				}
				self.add_notification(displayMessage, responseError.type);
			} else {
				self._cart_ele.removeClass('save_failed save_warning');
			}

			/* Clear the current request and handle waiting request
			.*-----------------------------------------*/
			self._save_attempt_count 	= 0;
			self._current_save_request 	= false;
			if(self._waiting_save_request) {
				self._waiting_save_request = false;
				self.save_product(callback);
			}
			callback();
		},
		error: function(/*jqXHR, textStatus, errorThrown*/) {


			/* Handle Retries
			.*-----------------------------------------*/
			if(self._save_attempt_count < self._max_retries) {
				rp_app.logger.error('Server error on cart update ... retrying (attempt: '+ self._save_attempt_count +')', 'rp_cart.js', 245); //@fixme - set real line numbers once things stop changing
				self.save_product(callback);
			} else {
				//console.log(jqXHR, textStatus, errorThrown);
				var error = 'Sorry, we can\'t save this item to the cart right now. Please try again later.';
				rp_app.logger.error('Server error on cart update ... MAX RETRIES REACHED', 'rp_cart.js', 249); //@fixme - set real line numbers once things stop changing
				self.add_notification(error, 'error');
				self._cart_ele.addClass('save_failed');

				/* Clear the current request and handle waiting request
				.*-----------------------------------------*/
				self._save_attempt_count 	= 0;
				self._current_save_request 	= false;
			}
		}
	});
}, 200);


/********************************************
* HTML Rendering
* -----------------------------------------
* @section html
********************************************/

RP_Cart.prototype.open_cart = function() {
	window.tracking = window.tracking || {}; // make sure object exists
	var tracking_page = window.tracking.page || 'other';
	var rp_product = this._current_product;
	if(!rp_product) { return; }

	/* Open Dialog
	.*-----------------------------------------*/
	if(rp_product.get_collect_vin() && !rp_product.get_vin()) {
		this.open_vin_dialog();
		window.rp_app.track.track_event(['AddToCart', 'CollectVIN', tracking_page]);
	} else {
		this.open_cart_dialog();
		window.rp_app.track.track_event(['AddToCart', 'Open', tracking_page]);
		const product_details = {
			id: get(rp_product, 'product_data.sku_stripped'),
			name: get(rp_product, 'product_data.name'),
			brand: get(rp_product, 'product_data.brand'),
			price: get(rp_product, 'product_data.sale_price'),
			quantity: 1
		};
		window.rp_app.track.track_ec_cart_event('add', product_details);
	}
};

RP_Cart.prototype.open_vin_dialog = function() {

	this.build_collect_vin_html();

	/* Fancybox Defaults
	.*-----------------------------------------*/
	var fancybox_opts = {
		parent: '#rp_webstore',
		closeBtn	: false,
		padding		: 2,
		wrapCSS		: 'vp_addtocart_fancybox',
		href		: '#'+ this._vin_ele_id,
		modal		: false,
		helpers 	: { overlay : { locked : false } }  /*solves bg 'shifting' issue*/
	};

	/* If Window is tall, determine where best to render the fancybox
	.*-----------------------------------------*/
	if(rp_app.iframe.height) {
		var win_h = rp$(window).height();
		var topRatio = 0.1;
		if(rp_app.iframe.scroll) {
			topRatio = (rp_app.iframe.scroll + rp_app.iframe.offset.top) / win_h;
		}
		fancybox_opts.topRatio = topRatio;
	}

	/* Open fancybox
	.*-----------------------------------------*/
	rp$.fancybox.open(fancybox_opts);
};

RP_Cart.prototype.open_cart_dialog = function() {
	//call facebook pixel tracking event
	var product_id = this._current_product.product_data.sku + '';
	product_id = product_id.replace(/[^a-z0-9]/gi,'');
	product_id = product_id.toLowerCase();
	if(typeof window.fbq !== 'undefined') {
		window.fbq('track', 'AddToCart',{
			'content_name' : this._current_product.product_data.title,
			'content_ids' : [product_id],
			'content_type' : 'product',
		});
	}

	this.build_html();

	/* Fancybox Defaults
	.*-----------------------------------------*/
	var fancybox_opts = {
		parent: '#rp_webstore',
		closeBtn	: false,
		padding		: 2,
		wrapCSS		: 'vp_addtocart_fancybox',
		href		: '#'+ this._cart_ele_id,
		modal		: false,
		helpers 	: { overlay : { locked : false } }  /*solves bg 'shifting' issue*/
	};

	/* If Window is tall, determine where best to render the fancybox
	* fancybox does this by setting a ratio of space instead of a top margin
	.*-----------------------------------------*/
	if(rp_app.iframe.height) {
		var win_h = rp$(window).height();
		var topRatio = 0.1; 	// Default topratio
		var modal_h = 300; 		// Height of the modal
		var modal_padding = 50; // padding from the top of the screen
		var available_h = win_h - (modal_h + modal_padding);

		// Only set the topRatio if we have scrolled beyond the top of the frame
		if(rp_app.iframe.scroll && rp_app.iframe.scroll > rp_app.iframe.offset.top) {
			var frame_scroll = rp_app.iframe.scroll - rp_app.iframe.offset.top; // amount scrolled over frame
			topRatio = frame_scroll / available_h; // take the amount we've scrolled against available height
			if(topRatio > 1) { topRatio = 1; } // modal can have more that 100% of space at the top
		}
		fancybox_opts.topRatio = topRatio;
	}

	/* Open fancybox
	.*-----------------------------------------*/
	rp$.fancybox.open(fancybox_opts);
};

/**
* Close the Chooser Element
*
* @author aspencer
* @return null
*/
RP_Cart.prototype.close_dialog = function() {
	rp$.fancybox.close();
};

/**
* Refresh size of dialog modal (usually done if contents change height)
*
* @author aspencer
* @return null
*/
RP_Cart.prototype.refresh_dialog = function() {
	window.setTimeout(function() {
		rp$('.fancybox-skin').height(rp$('#rp_global_add_to_cart').height()+5);
	}, 100);
};


RP_Cart.prototype.build_html = function() {
	this.build_dialog_html();
	this.build_cart_html();
};

RP_Cart.prototype.build_collect_vin_html = function() {
	var $ele = this._vin_ele;

	$ele.empty();

	var collect_vin_html = '';

	dust.render(collect_vin_templ, {
		product: this._current_product
	}, function(err, output) {
		if(err) {
			console.info(err);
		}
		collect_vin_html = output;
	});

	$ele.append(collect_vin_html);

	var self = this;
	rp$('#collect_vin_continue').on('click', function() {
		var vin_number = rp$('#collect-vin-value').val();
		self.collect_vin(vin_number);
	});
	rp$('#collect_vin_close').on('click', function() {
		self.close_dialog();
	});
};

RP_Cart.prototype.build_dialog_html = function() {

	this._cart_ele = this.global_ele(this._cart_ele_id);
	var $ele = this._cart_ele;

	this.update_totals();

	$ele.empty();

	var dialog_html = '';

	var image_is_centered = true;
	if(this._current_product.product_data.controlled || this._current_product.product_data.inventory_message) {
		image_is_centered = false;
	}

	// Determine whether to display list price
	var display_list_price = false;
	var product_msrp = this._current_product.get_msrp();
	var product_price = this._current_product.get_sale_price();
	if (product_msrp > 0 && product_price < product_msrp) {
		display_list_price = true;
	}

	dust.render(add_dialog_templ, {
		cart_total: this.subtotal,
		cart_count: this.item_count,
		cart_items: this.cart,
		checkout_url: this._checkout_url,
		added_product: this._current_product,
		product_image_is_centered: image_is_centered,
		currency_symbol: this._currency_symbol,
		currency_code: this._currency_code,
		display_list_price: display_list_price,
		punchout_session: this._punchout_session
	}, function(err, output) {
		if(err) {
			console.error(err);
		}
		dialog_html = output;
	});

	$ele.append(dialog_html);

	/* Attach Events
	.*-----------------------------------------*/
	var $inner_ele = $ele.find('.dialog_wrapper');

	/* Add onchange event to quantity in dialog
	.*-----------------------------------------*/
	var self = this;

	$inner_ele.on('keydown', '.added_product_quantity', quantityKeyHandler);
	$inner_ele.on('change, keyup', '.added_product_quantity', quantityChangeHandler);
	$inner_ele.find('.added_product_quantity')[0].oninput = quantityChangeHandler;
	/* Add Popover
	.*-----------------------------------------*/
	$inner_ele.find('.popover-tooltip').popover({
		trigger: 'hover',
		placement: 'bottom',
		// add 'template' option below to add 'rp-modal-popover', which is in turn to get around a bootstrap issue (see hacks.scss)
		template: '<div class="popover rp-modal-popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	}).addClass('my-super-popover');

	function quantityKeyHandler(e) {
		// Allow arrows (37/38/39/40), home/end (35/36), enter (13), delete and backspace (46/8), TAB (9), numpad 0-9 (96-105), and 0-9 (48-57)
		if ([8, 9, 13, 35, 36, 37, 38, 39, 40, 46].indexOf(e.which) === -1 &&
		(e.which < 48 || e.which > 57) && (e.which < 96 || e.which > 105)) {
			e.preventDefault();
		}
	}
	function quantityChangeHandler(/*e*/) {
		var localQuantity = parseInt(rp$(this).val(), 10);
		productQuantityUpdate(localQuantity);
	}
	function checkoutClickHandler(e) {
		e.preventDefault();
		var localQuantity = $inner_ele.find('.added_product_quantity').val();
		productQuantityUpdate(localQuantity);
		self.request_save_product({
			callback: function () {
				rp_app.location.redirect(self._checkout_url);
			},
		});
	}
	function continueClickHandler(/*e*/) {
		var localQuantity = $inner_ele.find('.added_product_quantity').val();
		productQuantityUpdate(localQuantity);
		self.request_save_product();
		self.close_dialog();
	}
	function replaceCartClickHandler(/*e*/) {
		window.rp_app.track.track_event(['AddToCart', 'SingleWarehouseRestriction', 'ReplaceCart']);
		self.clear_notifications();
		self.request_save_product({
			replace: true,
		});
	}

	function productQuantityUpdate(val) {
		self._current_product.set_quantity(val);
		self.update_totals();
		self.build_cart_html();
		self.request_save_product();
	}

	/* Click Events to go to cart page or continue shopping
	.*-----------------------------------------*/
	$inner_ele.on('click', '.add_cart_checkout', checkoutClickHandler);
	$inner_ele.on('click', '.add_cart_close', continueClickHandler);
	$inner_ele.on('click', '.replace-cart', replaceCartClickHandler);

	/* If the image is alone in its column, middle alignment
	.*-----------------------------------------*/
	// var $img_ele = $ele.find('.product_img_messages');
	// var $img_col = $ele.find('.product_img_col');
	// var $product_ele = $ele.find('.product_details_col');
	/* Doing a timeout for this check because we can't rely on load()
	window.setTimeout(function() {
	var img_calc_h = $img_ele.outerHeight() + 10;
	var ele_calc_h = $product_ele.outerHeight();
	$img_ele.height(img_calc_h);
	$img_ele.css({'position': 'absolute'});
	$img_col.height(ele_calc_h);
}, 150);
*/
};

RP_Cart.prototype.build_cart_html = function() {

	var cart_html = '';

	dust.render(cart_templ, {
		cart_id: this.cart_id,
		cart_total: this.subtotal,
		cart_count: this.item_count,
		cart_items: this.cart,
		currency_symbol: this._currency_symbol,
		currency_code: this._currency_code,
		checkout_url: this._checkout_url,
		start_checkout_url: this._start_checkout_url,
		use_product_link: true,
		prevent_checkout: this._prevent_checkout,
		paypal_ec_enabled: this._paypal_ec_enabled,
		paypal_ec_api_token: this._paypal_ec_api_token,
		paypal_ec_api_env: this._paypal_ec_api_env,
		is_webstore_plugin: rp_app.env.is_webstore_plugin,
	}, function(err, output) {
		if(err) {
			console.error(err);
		}
		cart_html = output;
	});


	/* Build total string
	.*-----------------------------------------*/
	var cart_total_out = NumberFormat.currency(this.subtotal);
	if(this._currency_code) {
		cart_total_out += '<span class="currency_code">'+this._currency_code+'</span>';
	}
	var cart_count_label = (this.item_count === 1) ? 'item' : 'items';

	/* Update DOM Elements
	.*-----------------------------------------*/
	rp$('.cart-items').html(this.item_count);
	if(this.item_count > 0) {
		rp$('.cart-items').addClass('cart-items-exist');
	} else {
		rp$('.cart-items').removeClass('cart-items-exist');
	}
	rp$('.cart-items-label').html(cart_count_label);
	rp$('.cart-total').html(cart_total_out);
	rp$('.cart_listing, .cart-flyout .cart-listing').html(cart_html);
};

RP_Cart.prototype.update_cart_promo_html = function(cart_promo_message) {
	let cart_promo_wrapper = rp$('.cart-promo-message-wrap');

	if (!cart_promo_wrapper.length) {
		return;
	}

	let cart_promo_html = '';

	dust.render(cart_promo_templ, {
		cart_promo_message: cart_promo_message,
	}, function(err, output) {
		if(err) {
			console.error(err);
		}
		cart_promo_html = output;
	});

	cart_promo_wrapper.html(cart_promo_html);
};

/********************************************
* Global Element Creation
* -----------------------------------------
* @section global_ele
********************************************/

RP_Cart.prototype.global_ele = function(global_ele_id) {
	var $global_ele = rp$('#'+ global_ele_id);
	if($global_ele.length === 0) {
		rp$('#rp_webstore').append('<div id="'+ global_ele_id +'" style="display:none"> </div>');
		$global_ele = rp$('#'+ global_ele_id);
	}
	return $global_ele;
};

/********************************************
* Notifications
* -----------------------------------------
* @section notifications
********************************************/
RP_Cart.prototype.add_notification = function(message, type) {
	var $notifications = rp$('#dialog_notification');

	message = '<p class="message">'+ message +'</p>';
	$notifications.append(message);
	$notifications.addClass(type);

	if(!$notifications.is(':visible')) {
		$notifications.show('fast', this.refresh_dialog);
	} else {
		this.refresh_dialog();
	}
};

RP_Cart.prototype.empty_notifications = function() {
	var $notifications = rp$('#dialog_notification');
	$notifications.empty();
};

RP_Cart.prototype.clear_notifications = function() {
	var $notifications = rp$('#dialog_notification');
	//var $content = rp$('#dialog_notification .container-wrap');
	$notifications.removeClass('error info warning');
	$notifications.empty();
	$notifications.hide('fast', this.refresh_dialog);
};

/********************************************
* Getters and Setters
* -----------------------------------------
* @section getters_setters
********************************************/

/* Current Product
.*-----------------------------------------*/
RP_Cart.prototype.set_current_product = function(rp_product) {
	this._current_product = rp_product;
};
RP_Cart.prototype.clear_current_product = function() {
	this._current_product = null;
};


/********************************************
* Bind the class to rp_app.cart
* -----------------------------------------
* @section binding
********************************************/
window.rp_app.cart = new RP_Cart();


/********************************************
* Jquery Plugin for "add to cart" buttons
* -----------------------------------------
* @section jquery
********************************************/

rp$.fn.add_to_cart = function() {
	const $requiredOptionSelects = rp$('#page-product .product-purchase-module').find('.option-select.option-required');
	$requiredOptionSelects.on('change', function () {
		rp$(this).removeClass('no-option-selected').popover('dispose');
	});

	return this.each(function() {
		// reset previous invalid product options
		$requiredOptionSelects.removeClass('no-option-selected').popover('dispose');
		rp$(this).on('click', function(event) {
			event.preventDefault();
			const $invalidSelects = $requiredOptionSelects.filter(function() {
				return !this.value;
			});
			if ($invalidSelects.length > 0) {
				// Add invalid class
				$invalidSelects.addClass('no-option-selected');
				// Show popover on first
				const $firstInvalidSelect = rp$($invalidSelects[0]);
				$firstInvalidSelect.popover('show');
				// Do NOT add to cart
				return false;
			}
			rp_app.cart.add_product_from_ele(this);
			rp_app.cart.open_cart();
		});
	});
};


onReady({rp$, window,
	label: 'cart-flyout',
	fn: function () {
		rp$('.cart-listing').on('click', '.paypal-button', (e) => {
			paypal.doPaypalCheckout(e);
		});
	},
});
